/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ServerConfig } from '@/types/app-config';

const config: ServerConfig = {
  apiBaseUrl: 'https://api400-mayoral.dev.prem.mayoral.net',
  graphql: {
    introspection: true,
    playground: true,
  },
};

export default config;
